//#region src/version.js
var e = "3.0.1";
//#endregion
export { e as version };

//# sourceMappingURL=version.js.map